import React from 'react';

export const documentation = {
    model: <div>The model object (of type flopy.modflow.Modflow) to which this package will be added.</div>,
    extension: <div>Filename extension</div>,
    unitnumber: <div>File unit number (default is None).</div>,

    // BAS
    porosity: <div>The porosity array.</div>,

};
